export const GTM_ID = "GTM-KZWWG29";

export const formEvent = ({ eventName, toolName }) => {
  window.dataLayer.push({
    event: eventName,
    tool_name: toolName,
  });
};
